// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstUserPosition {
constructor({
        id = null,
        userId = '',
        userIdName = '',
        mstPositionId = '',
        mstPositionName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.userId = userId;
    this.userIdName = userIdName;
    this.mstPositionId = mstPositionId;
    this.mstPositionName = mstPositionName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstUserPosition();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'userIdLoginName',
        label: 'label.sith.mst.sithMesMstUserPosition.grid.userIdLoginName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'userIdName',
        label: 'label.sith.mst.sithMesMstUserPosition.grid.userIdName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstPositionId',
        label: 'label.sith.mst.sithMesMstUserPosition.grid.mstPositionId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstPositionName',
        label: 'label.sith.mst.sithMesMstUserPosition.grid.mstPositionName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstUserPosition.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    userIdFilter : "",
    userIdNameFilter : "",
    mstPositionIdFilter : "",
    mstPositionNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'userIdNameFilter',
        label: 'label.sith.mst.sithMesMstUserPosition.filter.userIdName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"userId":"id"}'
                }
        },
        {
        key: 'mstPositionNameFilter',
        label: 'label.sith.mst.sithMesMstUserPosition.filter.mstPositionName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstPositionId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'userIdName',
        label: 'label.sith.mst.sithMesMstUserPosition.entity.userIdName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"userId":"id"}'
                }
        },
        {
        key: 'mstPositionName',
        label: 'label.sith.mst.sithMesMstUserPosition.entity.mstPositionName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstPosition'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstPositionId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstUserPosition.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstUserPosition, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
